import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import GiftItem from '../../GiftItem';
import { DEFAULT_COUNTRY_CODE } from '../../../utils/constants';

import s from './index.module.scss';

const BBGiftsGrid = ({ heading = '', items }) => {
  const products = useSelector((state) => state.productsStorage.gifts);
  const gifts = [];

  items.forEach((id) => {
    if (products[id]) {
      gifts.push(
        <GiftItem
          product={products[id]}
          key={id}
          variant={DEFAULT_COUNTRY_CODE === 'GB' ? 'modern' : 'default'}
        />,
      );
    }
  });

  const itemsPerRow = DEFAULT_COUNTRY_CODE === 'GB' ? 4 : 3;
  return (
    <div className={`bb ${s['bb-gifts-grid']}`}>
      <div className="container">
        {heading && <h3 className={s['bb-gifts-grid__title']}>{heading}</h3>}
        <div
          className={`${s['bb-gifts-grid__items']} ${s[`bb-gifts-grid__${itemsPerRow}-items-per-row`]}`}
        >
          {gifts}
        </div>
      </div>
    </div>
  );
};

BBGiftsGrid.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default BBGiftsGrid;
